import { BrowserRouter } from 'react-router-dom';

import { ErrorBoundary } from '@/app/ErrorBoundary';
import { AppRoutes } from '@/app/routes';
import { ScrollRestoration } from '@/app/ScrollRestoration';
import { QueryProvider, ThemeProvider } from '@/app/providers';
import { AppShell } from '@/components/layout';
import { AuthProvider } from '@/features/auth/AuthProvider';

/**
 * Composition root.
 *
 * Provider order matters: the error boundary is outermost so a failure in any
 * provider or page still renders a usable screen; auth sits inside the query
 * client so profile queries can run; the router sits above the shell because
 * the navigation bar uses route state.
 */
export function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <QueryProvider>
          <BrowserRouter>
            <AuthProvider>
              <ScrollRestoration />
              <AppShell>
                <AppRoutes />
              </AppShell>
            </AuthProvider>
          </BrowserRouter>
        </QueryProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
